import { Box } from '@mui/material';
import {
  CarouselItem,
  MgCarousel,
  useCarouselPreview,
  NoImageElement,
} from '@retail/products/components';
import { useFetchMgItemMarketing } from '@retail/products/data-access';
import { useMemo, useState } from 'react';
import { MgItemMarketing } from '@retail/products/types';

interface Props {
  mgItemNumber: number;
}

export function MgItemGallery({ mgItemNumber }: Props) {
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const { data: itemMarketingDTO } = useFetchMgItemMarketing({ mgItemNumber });
  const mgItemMarketing = itemMarketingDTO ? MgItemMarketing.fromDto(itemMarketingDTO) : undefined;

  const items: CarouselItem[] = useMemo(() => {
    return Object.entries(mgItemMarketing || {})
      .map(([key, value]) => {
        if (value) {
          return {
            url: value,
            description: key,
          } as CarouselItem;
        }
        return null;
      })
      .filter((item): item is CarouselItem => item !== null);
  }, [mgItemMarketing]);

  const { goToSnapItem } = useCarouselPreview(items.length);

  const handlePreviousClick = (num: number) => {
    if (num >= 0) {
      setActiveSlide(num);
      goToSnapItem(num);
    }
  };

  const handleNextClick = (num: number) => {
    if (num <= items.length - 1) {
      setActiveSlide(num);
      goToSnapItem(num);
    }
  };

  return (
    <Box display="flex" height="inherit">
      <Box sx={{ width: '100%', height: 'inherit' }}>
        <MgCarousel
          items={items}
          activeSlide={activeSlide}
          handlePreviousClick={handlePreviousClick}
          handleNextClick={handleNextClick}
          fallbackElement={<NoImageElement isPreview={false} />}
        />
      </Box>
    </Box>
  );
}
